/**
 * Log retention (System service, SystemDb migration 269).
 * One policy per shared log table (AppLog, ApiRequestLog, QueryPerformanceLog), applied by the
 * single LogRetentionJob in CCMS.Worker.ScheduledJobs. Admin only.
 *
 * Mirror of `System/ModelView/LogRetentionPolicyView.cs`, `LogRetentionPolicyUpdateRequest`
 * and `LogRetentionRunStatusIds` / `LogRetentionTables` limits.
 */
/**
 * LogRetentionRunStatus lookup ids. Names come from the seeded lookup table and are echoed on
 * every policy as `lastRunStatusName`; these constants only exist so callers can branch
 * without string matching.
 */
export const LogRetentionRunStatusIds = {
    Succeeded: 1,
    /** Time budget reached; the next hourly pass carries on. */
    Partial: 2,
    Failed: 3,
    /** Cleaning switched off, or the table does not exist. */
    Skipped: 4,
    Running: 5,
};
/** Setting limits enforced by the API (and a database CHECK constraint). */
export const LogRetentionLimits = {
    minRetentionDays: 1,
    maxRetentionDays: 3650,
    minBatchSize: 50,
    /** Above ~5 000 row locks SQL Server escalates to a table lock, blocking every log writer. */
    maxBatchSize: 4000,
    minRunMinutes: 1,
    maxRunMinutes: 120,
};
//# sourceMappingURL=LogRetention.js.map